import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getDeviceId } from './deviceId';

const paymentApi = axios.create({ baseURL: API_BASE_URL });
paymentApi.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});
paymentApi.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export default paymentApi;
